export const LOGIN = 'Login';
export const SIGNUP = 'Sign-up';
export const SIGNUP_PROMO = 'Sign-up Promo';
export const REGISTRATION_CONFIRM = 'RegistrationConfirm';
export const INVITATION_CONFIRM = 'InvitationConfirm';
export const FORGOT_PASSWORD = 'Forgot password';
export const DASHBOARD = 'Dashboard';
export const CLASS_PAGE = 'My classes';
export const CLASS_CALENDAR = 'Class calendar';
export const CLASS_FORM = 'Add class';
export const CLASS_EDIT_FORM = 'Edit class';
export const CLASS_ROSTERS = 'Class rosters';
export const CLASS_WAIT_LIST = 'Class wait list';
export const CLASS_ATTENDANCE = 'Class attendance';
export const PUBLIC_CLASS_CALENDAR = 'Public class calendar';
export const PUBLIC_CLASS_LIST = 'Public class list';
export const CAMP_PAGE = 'My camps';
export const CAMP_CALENDAR = 'Camp calendar';
export const CAMP_FORM = 'Add camp';
export const CAMP_EDIT_FORM = 'Edit camp';
export const CAMP_ROSTERS = 'Camp rosters';
export const CAMP_WAIT_LIST = 'Camp wait list';
export const CAMP_ATTENDANCE = 'Camp attendance';
export const PUBLIC_CAMP_CALENDAR = 'Public camp calendar';
export const PUBLIC_CAMP_LIST = 'Public camp list';
export const AFTERCARE_PAGE = 'After Care';
export const AFTERCARE_CALENDAR = 'After Care calendar';
export const AFTERCARE_FORM = 'Add After Care';
export const AFTERCARE_EDIT_FORM = 'Edit After Care';
export const AFTERCARE_ROSTERS = 'After Care rosters';
export const AFTERCARE_WAIT_LIST = 'After Care wait list';
export const AFTERCARE_DROP_IN = 'After Care drop-in';
export const AFTERCARE_ATTENDANCE = 'After Care attendance';
export const PUBLIC_AFTERCARE_CALENDAR = 'Public After Care calendar';
export const PUBLIC_AFTERCARE_LIST = 'Public After Care list';
export const CONTACTS_PAGE = 'Contacts';
export const TRANSACTIONS = 'Transactions';
export const INVOICES ='Invoices';
export const COUPONS = 'Coupons';
export const REPORTS_PAGE = 'Reports';
export const SETTINGS_LIST_PAGE = 'SettingsList';
export const PERSONAL_INFO_PAGE = 'Personal info';
export const PROFILE_PAGE = 'Profile';
export const NOTIFICATIONS_PAGE = 'Notifications';
export const WIDGETS_PAGE = 'Widgets';
export const SETTINGS_PAGE = 'Settings';
export const TEACHERS_PAGE = 'Homeroom Teachers';
export const PICKUP_OPTIONS_PAGE = 'Pickup Options';
export const TSHIRTS_PAGE = 'T-Shirt';
export const LOCATIONS_PAGE = 'Locations';
export const POLICIES_PAGE = 'Policies';
export const BILLING_PAGE = 'Billing';
export const SMS_HISTORY_PAGE = 'SMS History';
export const EMAIL_HISTORY_PAGE = 'Email History';
export const USERS_PAGE = 'Users';
export const APPS_PAGE = 'Apps';
export const PAGE404 = 'Page-404';
export const PAGE_ACCOUNT_SUSPENDED = 'Account suspended';
export const PARENT_PORTAL = 'Parent Portal';
export const CUSTOM_FORMS_PAGE = 'Custom Forms';
export const CUSTOM_FORMS_CREATE_FORM = 'Add form';
export const CUSTOM_FORMS_EDIT_FORM = 'Edit form';


// WEBPACK FOOTER //
// ./src/router/routes.js